/**
 * Base API sans slash final.
 * Une base "/" ou vide produirait des URLs du type "//document-categories/sync"
 * (interprétation incorrecte par le navigateur) — on retombe sur "/api".
 */
function normalizeApiBaseUrl(raw) {
  if (raw == null) return "/api";
  const s = String(raw).trim();
  if (!s || s === "/") return "/api";
  return s.replace(/\/+$/, "");
}

export function getApiBaseUrl() {
  const win =
    typeof window !== "undefined" &&
    window.__ENV__ != null &&
    window.__ENV__.REACT_APP_API_URL != null
      ? String(window.__ENV__.REACT_APP_API_URL)
      : "";
  const env =
    typeof process !== "undefined" && process.env.REACT_APP_API_URL != null
      ? String(process.env.REACT_APP_API_URL)
      : "";
  return normalizeApiBaseUrl(win.trim() || env.trim());
}

/** Concatène la base avec un chemin (/login, /document-categories/sync, …). */
export function buildApiUrl(path) {
  const rawPath = typeof path === "string" ? path.trim() : "";
  if (!rawPath) {
    throw new Error("Chemin API invalide.");
  }
  const normalizedPath = rawPath.startsWith("/") ? rawPath : `/${rawPath}`;
  const base = getApiBaseUrl();

  if (base.startsWith("http://") || base.startsWith("https://")) {
    return `${base}${normalizedPath}`;
  }

  const prefix = base.startsWith("/") ? base : `/${base}`;
  return `${prefix}${normalizedPath}`;
}

export default getApiBaseUrl;
